export const LOCAL_STORAGE = {
    customerNo: Number(localStorage.getItem('customerNo')),
    userId: Number(localStorage.getItem('userId')),
    userToken: localStorage.getItem('apiToken'),
    role: localStorage.getItem('role'),
    customerLogo: localStorage.getItem('customerLogo'),
    locales: localStorage.getItem("locales"),
}